import { z } from 'zod';

export const ERROR_MESSAGE_MAX_LENGTH = 300;
export const ERROR_DETAIL_MAX_LENGTH = 2000;

/** An error in the browser, sent so the admin learns about it before the children do (M11). */
export const clientErrorReportSchema = z.object({
  message: z.string().trim().min(1).max(ERROR_MESSAGE_MAX_LENGTH),
  detail: z.string().max(ERROR_DETAIL_MAX_LENGTH).optional(),
  page: z.string().max(200).optional(),
});

export type ClientErrorReport = z.infer<typeof clientErrorReportSchema>;

/** One kind of error on one day, as the admin sees it. */
export interface ErrorSummary {
  source: 'server' | 'client';
  message: string;
  detail: string | null;
  day: string;
  count: number;
  lastAt: number;
}

/** The admin's overview of how the server is doing. */
export interface ServerStatus {
  startedAt: number;
  rooms: number;
  playersOnline: number;
  unseenReports: number;
  /** The last 7 days, newest first. */
  errors: ErrorSummary[];
}
